import { render, staticRenderFns } from "./AccountingConfig.vue?vue&type=template&id=19ce2cec"
import script from "./AccountingConfig.vue?vue&type=script&lang=js"
export * from "./AccountingConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports